module.exports = __webpack_public_path__ + "img/1.353b28a5.jpg";